/* eslint-disable no-shadow */
// import Immutable from 'seamless-immutable';
import createReducer from '../../helpers/createReducer';
import {
  gamification as state
} from '../store';

export default createReducer(state, {
  SET_PASSED_RF_QUIZ: (state, { data: hasPassedRfQuiz }) => ({ ...state, hasPassedRfQuiz }),
  SET_PASSED_LM_QUIZ: (state, { data: hasPassedLmQuiz }) => ({ ...state, hasPassedLmQuiz }),
  SET_PASSED_MM_QUIZ: (state, { data: hasPassedMmQuiz }) => ({ ...state, hasPassedMmQuiz }),
  SET_BADGE: (state, { data: badges }) => ({ ...state, badges }),
  SET_WHOLE_GAMIFICATION: (state, { data }) => ({ ...state, ...data })
});
